import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { APIProject, ProjectsService } from 'src/app/services/projects.service';
import { AuthService } from 'src/app/auth/auth.service';
import { UsersService } from '../../../services/users.service';
import { ProjectStatus } from '../../interfaces/projects';

@Component({
  selector: 'app-top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.scss'],
})
export class TopBarComponent implements OnInit {
  userPicture = '../../../assets/img/user-img.webp';
  title?: string;
  description!: string;

  constructor(
    public router: Router,
    private authService: AuthService,
    private projectService: ProjectsService,
    private activatedRoute: ActivatedRoute,
    private userServices: UsersService,
  ) {
    this.router.events.subscribe(async (event) => {
      if (event instanceof NavigationEnd) {
        if (event?.url.slice(event?.url.length - 8) === 'invoices' && event?.url.includes('projects')) {
          const projects: APIProject[] = await this.projectService.getProjects();
          const id = this.router.url.substring(
            this.router.url.substring(1).indexOf('/') + 2,
            this.router.url.lastIndexOf('/'),
          );
          const project = projects.find((x) => x.id === id);
          const projectName = project?.name;
          this.title = `${projectName ?? ''} Invoices`;
          if (project?.status === ProjectStatus.CLOSED) this.description = 'This screen shows only closed projects.';
          if (project?.status !== ProjectStatus.CLOSED)
            this.description = `Create, manage and approve ${projectName ?? ''} invoices. Configure schedule options such as requires approval, auto send, recipients and more.`;
        } else this.getTitle();
      }
    });
  }

  ngOnInit(): void {
    // User avatar is not provided by the Supabase email/password pool; the
    // default placeholder image is used.
  }

  getTitle() {
    this.title = this.router.url;

    if (this.router.url === '/') {
      this.title = 'Dashboard';
      this.description = 'Get the most important reports from your company you need to know.';
    } else if (this.router.url === '/all-invoices') {
      this.title = 'All Invoices';
      this.description = 'Filter invoices by project. Find archive old invoices. Know their status and details.';
    } else {
      this.title = this.router.url.substring(1);
      this.description = '';
      switch (this.router.url) {
        case '/clients':
          this.description = 'Manage your clients. Get to know the project amount of the client.';
          break;
        case '/products':
          this.description = 'Register and manage a product with its values, icons and more.';
          break;
        case '/recipients':
          this.description = 'Email recipients to the invoices being a copy or a primary.';
          break;
        case '/projects':
          this.description = 'Manage client projects. Get to know their status and the invoices amount.';
          break;
        default:
          break;
      }
    }
  }

  async navigate(page: string) {
    await this.router.navigate([`/${page}`]);
  }

  logOut() {
    void this.userServices.clearCache();
    void this.authService.signOut();
  }
}
